<div class="top">
  <h2 mat-dialog-title>
    <mat-icon svgIcon="socket_type_ccs2"></mat-icon>
    Vælg ladepunkter
  </h2>
  @if (allConnectorLocationItems.length > 0) {
    <a (click)="loadselectedConnectors()" class="top__chosen btn-icon">
      <div matBadge="{{ selectedConnectors.length }}" matBadgeOverlap="false">Valgt</div>
    </a>
    <a (click)="resetConnectors()" class="top__reset btn-icon">Nulstil valg</a>
  }
  <button class="btn-close btn-icon" mat-dialog-close>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<mat-dialog-content [formGroup]="filterModel">
  <div class="actions">
    <div class="form-row form-row--inline">
      @if (allConnectorLocationItems.length > 0) {
        <mat-form-field class="actions__query">
          <mat-label>Filtrer lokationer / ladepunkter</mat-label>
          <input matInput placeholder="Lokations- eller ladestandernavn" formControlName="query" />
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      }
    </div>
    <div class="form-row form-row--inline">
      <mat-checkbox (click)="loadselectedConnectors()" [checked]="toggleSelectedConnectors" [color]="'primary'">Vis valgte</mat-checkbox>
    </div>
  </div>

  @if (allConnectorLocationItems.length === 0 && !loading()) {
    <em> Der kunne ikke findes nogen ladepunkter for den valgte organisation. </em>
  }
  @if (allConnectorLocationItems.length > 0) {
    <div>
      <div mat-dialog-content class="connectors-selector">
        <adm-loading-spinner [loadingSignal]="loading()"></adm-loading-spinner>
        @if (filteredConnectorLocationItems.length === 0 && query.value) {
          <div class="text-center">
            Der kunne ikke findes nogen matches på
            <em>{{ query.value }}</em>
          </div>
        }
        @if (filteredConnectorLocationItems.length > 0) {
          <table class="table tiny-text">
            <tr>
              <th>
                <mat-checkbox formControlName="selectAllLocations" [matTooltip]="'Vælg alle på listen'"> Lokation </mat-checkbox>
              </th>
              <th>Addresse</th>
              <th>Afdeling</th>
            </tr>
            @for (connectorLocation of filteredConnectorLocationItems; track connectorLocation.chargingStationLocationIdentifier) {
              <tr class="locations" [class.locations--has-connectors]="hasAvailableConnectors(connectorLocation)">
                <td
                  [matTooltip]="!hasAvailableConnectors(connectorLocation) ? 'Der er ingen tilgængelige ladestandere på lokationen.' : ''">
                  <mat-checkbox
                    [checked]="connectorLocation.allSelected"
                    [indeterminate]="someSelected(connectorLocation)"
                    (change)="selectAll(connectorLocation)"
                    [disabled]="!hasAvailableConnectors(connectorLocation)">
                    {{ connectorLocation.name }}
                  </mat-checkbox>
                </td>
                <td>
                  {{ connectorLocation.address }}
                </td>
                <td>
                  {{ connectorLocation.departmentName }}
                </td>
              </tr>
              @if (connectorLocation.connectors.length > 0) {
                <tr>
                  <td class="connectors" colspan="3">
                    <table class="table">
                      <tr>
                        <th class="adjust-for-checkbox"></th>
                        <th>Ladestander</th>
                        <th class="align-center">Ladepunkt</th>
                        <th class="align-center">Effekt</th>
                        <th class="align-center">Type</th>
                        <th class="align-left">
                          <div class="icon-with-text">
                            <span>Forbrugerpris</span>
                            <svg
                              class="icon-20 margin--left-xs cursor-help"
                              [matTooltip]="'Forbrugerprisen er en samlet pris for strømsats, eventuelle tillæg og inkl. moms'">
                              <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
                            </svg>
                          </div>
                        </th>
                      </tr>
                      @for (connector of connectorLocation.connectors; track connector.connectorIdentifier) {
                        <tr>
                          <td class="adjust-for-checkbox">
                            <mat-checkbox
                              (change)="updateParent(connectorLocation, connector)"
                              [checked]="connector.isSelected"
                              [value]="connector.connectorIdentifier"
                              [disabled]="connector.isAttachedToDifferentTerminal">
                            </mat-checkbox>
                          </td>
                          <td
                            [class.disabled-text]="connector.isAttachedToDifferentTerminal"
                            [matTooltip]="
                              connector.isAttachedToDifferentTerminal ? 'Ladepunktet er allerede tilknyttet en anden terminal' : ''
                            ">
                            {{ connector.chargingStationIdentifier }}
                          </td>
                          <td class="align-center">{{ connector.stationNumber }}</td>
                          <td class="align-center">{{ connector.power }} kWh</td>
                          <td class="align-center">{{ connector.connectorType }}</td>
                          <td class="align-left">
                            @if (connector.priceType === pricetypes.Fixed) {
                              {{ connector.consumerPricePerKwh | dkCurrency }}
                            } @else {
                              <div class="icon-with-text">
                                <span>{{ connector.consumerPricePerKwh | dkCurrency }}</span>
                                <svg
                                  class="icon-20 margin--left-xs cursor-help orange"
                                  [matTooltip]="'Stikket afregnes efter en dynamisk prismodel. Det betyder, at elprisen følger markedsprisen og reguleres hvert kvarter.'">
                                  <use href="assets/images/ok-icons-sprite.svg#info-s"></use>
                                </svg>
                              </div>
                            }
                          </td>
                        </tr>
                      }
                    </table>
                  </td>
                </tr>
              }
            }
          </table>
        }
      </div>
    </div>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  @if (allConnectorLocationItems.length > 0) {
    <button class="actions__button" type="submit" mat-flat-button color="primary" (click)="saveAndClose()">Anvend</button>
  }
  @if (allConnectorLocationItems.length === 0 && !loading()) {
    <button class="actions__button" type="button" mat-flat-button color="primary" mat-dialog-close>Luk</button>
  }
</mat-dialog-actions>
